import React from 'react';
import sr_color_logo from '../../images/skillrobo logo.png';

const Logo = props => <img {...props} src={sr_color_logo} alt="Logo" />;
export default Logo;
